<template>
  <div v-if="countTiles && countTiles.length" class="count_tiles my-4">
    <div v-for="(item, index) in countTiles" :key="index" class="">
      <a :href="item.uri" target="_blank"
        class="body_style_card bg-white custom_box_shadow text-center cursor_pointer  p-3 py-4 d-block  align-items-center"
        :style="[{ background: isGradient ? transparentColor : '#fff' }]" :class="{ disabledContent: !isLastIndex }">
        <div v-if="item.count === 0">
          <img :src="item.imageUrl" alt="" srcset="" class="img-fluid" v-if="item.imageUrl" />
          <NoVehicle v-else />
          <!-- <img src="../../../../../../images/no-image.png" alt="" srcset="" class="img-fluid" v-else /> -->
        </div>
        <div class="text-center count_container mb-1" v-if="item.count > 0">
          <h4 class="_theme_font_bold text-black mb-0" :style="[{ color: isGradient ? textColor : '#000' }]">{{
            item.count }}
          </h4>
          <small>in stock</small>
        </div>
        <div class="col-12 mb-2">
          <p class="mb-0 text-black font-weight-bold" :style="[{ color: isGradient ? textColor : '#000' }]">{{ item.name
          }}</p>
        </div>
        <div>
          <button class="btn rounded-buttons text-white btn-block"
            :class="[isGradient ? 'transparent-bg' : 'bgcolor-primary']">{{ item.displayName }}</button>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
import NoVehicle from './NoVehicle.vue';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      countTiles: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000',
    }
  },

  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.countTiles = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    if (this.isGradient) {
      this.primaryColor = '#fff';
      this.transparentColor = 'rgba(0, 0, 0, 0.1) !important';
      this.textColor = '#fff';
    }

    console.log(this.botResponse, 'ccc')

  },
  methods: {
    eachBodyStyle(item, index) {
      // let specialObject = { TvmComponentRequest: item.name };
      ChatWidgetService.postTvmMessage(item.name, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction);
      this.isChecked = index;
    }
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  components: {
    NoVehicle
  }
}
</script>
<style lang="less" scoped>
.count_tiles {
  gap: 25px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  a {
    color: #000;
    text-decoration: none;
  }

  p {
    font-size: 20px;
    min-height: 50px;
  }

  img {
    max-height: 130px;
  }

  .count_container {
    min-height: 130px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }

  .img_card {
    padding: 25px 30px;
  }
}

.body_style_card {
  border-radius: 10px;

  h4 {
    font-size: 60px;
    opacity: 0.5;
  }

  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .cursor_pointer {
    cursor: pointer;
  }

}
</style>
